enum BusinessHoursStatus {
    Active = 90,
    Deleted = 100
}

export default BusinessHoursStatus;